export default __webpack_public_path__ + "static/media/featured-axios.1f4199f5.webp";